<template>
  <div :class="[$style.container, $style.modal]">
    <ModalHeader
      :centered="true"
      :handleClose="handleClose"
      headerText="How JumpCloud Binding works"
      :showClose="true"
    />
    <div :class="$style.modalBody">
      <div :class="$style.subHeaderText">
        Did you know that if a user’s JumpCloud username doesn’t match their
        device’s local profile name, rather than taking over an existing profile,
        we create a new profile with the user’s JumpCloud username.
        <a
          href="https://support.jumpcloud.com/support/s/article/how-the-jumpcloud-agent-works1"
          rel="noopener noreferrer"
          target="_blank"
        >
          Learn more.
        </a>
      </div>
      <img src="img/icons/icon-first-bind-modal.svg">
    </div>
    <ModalFooter
      :centered="true"
      :handleClose="handleClose"
      :handleMainAction="handleMainAction"
      mainActionText="continue"
    />
  </div>
</template>

<script>
import ModalFooter from 'components/Modal/ModalComponents/ModalFooter.vue';
import ModalHeader from 'components/Modal/ModalComponents/ModalHeader.vue';

export default {
  name: 'BindToUserTutorialModal',

  components: {
    ModalFooter,
    ModalHeader,
  },

  props: {
    handleClose: {
      type: Function,
      default: () => {},
    },

    handleMainAction: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style scoped module>
img {
  width: 100%;
}

img:focus {
  outline: none;
}

.modalBody {
  padding: 0 60px 25px;
  text-align: center;
}

.subHeaderText {
  display: inline-block;
  margin-bottom: 40px;
  max-width: 700px;
}
</style>
